import React, { useEffect, useState } from "react";
import { ExportOutlined, SearchOutlined } from "@ant-design/icons";
import { useTypedSelector } from "../../store";
import { Navigate, useNavigate } from "react-router-dom";
import {
  Button,
  DatePicker,
  Image,
  Input,
  Modal,
  Skeleton,
  Space,
  Table,
} from "antd";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import { ColumnsType } from "antd/es/table";
import { useDispatch } from "react-redux";
// import {
//   approvalLeaveAllRequest,
//   approvalLeaveRequest,
//   getLeaveReportRequest,
// } from "../../slices/leave";
import {
  getAttendanceRequest,
  updateApprovalAttendanceAllRequest,
  updateApprovalAttendanceRequest,
} from "../../slices/attendance";

interface DataType {
  _id: string;
  date: string;
  employeeId: string;
  name: string;
  department: string;
  location: string;
  location_in: string;
  location_out: string;
  time_in: string;
  time_out: string;
  imageIn: string | null;
  imageOut: string | null;
  notes: string;
  rejectedNotes: string | null;
  requestStatus: string;
  shiftCode: string;
  shiftIn: string;
  shiftOut: string;
  createdAt: string;
  updatedAt: string;
}

const Attendance: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authData, isLogin, lists, loading, isChange, updateAll } =
    useTypedSelector((state) => {
      return {
        authData: state.Auth.loginData,
        isLogin: state.Auth.isLogin,
        lists: state.Attendance.reportListRequest,
        loading: state.Leave.pageIsLoading,
        isChange: state.Attendance.updateRequest,
        updateAll: state.Attendance.approveAll,
      };
    });
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState<any>(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState<any>(dayjs().endOf("month"));
  const [filteredData, setFilteredData] = useState<any[]>(lists);

  console.log(authData, isLogin);

  const handleApprove = (id: string, status: string) => {
    let payload = {};
    console.log("ST", status);

    if (status === "rejected") {
      // requestStatus: "rejected",
      //   rejectedNotes: notes,
      payload = {
        id: id,
        requestStatus: "rejected",
        rejectedNotes: "Di Tolak oleh HC",
      };
    } else {
      payload = {
        id: id,
        requestStatus: "approved",
        rejectedNotes: "Di setujui oleh HC",
      };
    }
    // Tambahkan logic untuk API call atau Redux dispatch di sini

    console.log("PAY", payload);

    dispatch(updateApprovalAttendanceRequest(payload) as any);
  };

  useEffect(() => {
    if (!isLogin) {
      navigate("/login");
    } else {
      dispatch(
        getAttendanceRequest({
          startdate: startDate.format("YYYY-MM-DD"),
          enddate: endDate.format("YYYY-MM-DD"),
        }) as any
      );
    }
  }, [isLogin, dispatch, navigate, startDate, endDate, isChange, updateAll]);

  useEffect(() => {
    // Perbarui filteredData setiap kali employees berubah
    if (lists.length > 0) {
      console.log("LIST", lists);

      setFilteredData(lists);
    } else {
      setFilteredData([]);
    }
  }, [lists]);

  const handleApproveAll = () => {
    dispatch(updateApprovalAttendanceAllRequest() as any);
  };

  const handleSearchText = (value: string) => {
    setSearchText(value);
    const filtered = lists.filter(
      (leave) =>
        leave.name.toLowerCase().includes(value.toLowerCase()) ||
        leave.employeeId.toLowerCase().includes(value.toLowerCase()) ||
        leave.department.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };
  const handleSearch = () => {
    //   setIsLoading(true);
    // Logika untuk pencarian berdasarkan tanggal
    console.log(
      "Searching from",
      startDate.format("YYYY-MM-DD"),
      "to",
      endDate.format("YYYY-MM-DD")
    );
    dispatch(
      getAttendanceRequest({
        startdate: startDate.format("YYYY-MM-DD"),
        enddate: endDate.format("YYYY-MM-DD"),
      }) as any
    ).then((res: any) => {
      // setIsLoading(false)
      setFilteredData(res.payload);
    });
  };

  console.log("FD", filteredData);

  const handleExportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Request");
    XLSX.writeFile(workbook, "attendance_request_reports.xlsx");
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Employee ID",
      dataIndex: "employeeId",
      key: "employeeId",
      sorter: (a: any, b: any) =>
        (a.employeeId || "").localeCompare(b.employeeId || ""),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a: any, b: any) => (a.date || "").localeCompare(b.date || ""),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "Location Job",
      dataIndex: "location",
      key: "location",
      sorter: (a: any, b: any) =>
        (a.location || "").localeCompare(b.location || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Departement",
      dataIndex: "department",
      key: "department",
      sorter: (a: any, b: any) =>
        (a.department || "").localeCompare(b.department || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Location In",
      dataIndex: "location_in",
      key: "location_in",
      sorter: (a: any, b: any) =>
        (a.location_in || "").localeCompare(b.location_in || ""),
    },
    {
      title: "Location Out",
      dataIndex: "location_out",
      key: "location_out",
      sorter: (a: any, b: any) =>
        (a.location_out || "").localeCompare(b.location_out || ""),
    },
    {
      title: "Time In",
      dataIndex: "time_in",
      key: "time_in",
      sorter: (a: any, b: any) =>
        (a.time_in || "").localeCompare(b.time_in || ""),
    },
    {
      title: "TimeOut",
      dataIndex: "time_out",
      key: "time_out",
      sorter: (a: any, b: any) =>
        (a.time_out || "").localeCompare(b.time_out || ""),
    },
    {
      title: "Image In",
      dataIndex: "imageIn",
      key: "imageIn",
      render: (text: string) =>
        text ? (
          <Image
            width={50}
            src={text}
            preview={{ mask: "Click to Zoom" }} // Zoom hanya saat diklik
          />
        ) : (
          "--"
        ),
    },
    {
      title: "Image Out",
      dataIndex: "imageOut",
      key: "imageOut",
      render: (text: string) =>
        text ? (
          <Image
            width={50}
            src={text}
            preview={{ mask: "Click to Zoom" }} // Zoom hanya saat diklik
          />
        ) : (
          "--"
        ),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      sorter: (a: any, b: any) => (a.notes || "").localeCompare(b.notes || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Status",
      dataIndex: "requestStatus",
      key: "requestStatus",
      sorter: (a: any, b: any) =>
        (a.requestStatus || "").localeCompare(b.requestStatus || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Approve Notes",
      dataIndex: "rejectedNotes",
      key: "rejectedNotes",
      sorter: (a: any, b: any) =>
        (a.rejectedNotes || "").localeCompare(b.rejectedNotes || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Schedule",
      dataIndex: "shiftCode",
      key: "shiftCode",
      sorter: (a: any, b: any) =>
        (a.shiftCode || "").localeCompare(b.shiftCode || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Schedule In",
      dataIndex: "shiftIn",
      key: "shiftIn",
      sorter: (a: any, b: any) =>
        (a.shiftIn || "").localeCompare(b.shiftIn || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Schedule Out",
      dataIndex: "shiftOut",
      key: "shiftOut",
      sorter: (a: any, b: any) =>
        (a.shiftOut || "").localeCompare(b.shiftOut || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: DataType) => (
        <>
          <Button
            type="primary"
            onClick={() => handleApprove(record._id, "approved")}
            style={{ marginRight: 10 }}
            disabled={record.requestStatus !== "review"}
          >
            Approve
          </Button>
          <Button
            type="primary"
            onClick={() => handleApprove(record._id, "rejected")}
            disabled={record.requestStatus !== "review"}
            danger
          >
            Reject
          </Button>
        </>
      ),
    },
  ];
  return (
    <div>
      <Space
        style={{
          marginBottom: 16,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Space>
          <Input
            placeholder="Search by name or EID"
            value={searchText}
            onChange={(e) => handleSearchText(e.target.value)}
            prefix={<SearchOutlined />}
            style={{ maxWidth: 300 }}
          />
          <DatePicker
            value={startDate}
            onChange={(date) => setStartDate(date ? date : dayjs())}
            placeholder="Start Date"
          />
          <DatePicker
            value={endDate}
            onChange={(date) => setEndDate(date ? date : dayjs())}
            placeholder="End Date"
          />
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearch}
          />
        </Space>
        <div>
          <Button
            style={{
              backgroundColor: "#00A65A",
              borderColor: "#00A65A",
              color: "#fff",
            }}
            icon={<ExportOutlined />}
            onClick={handleExportToExcel}
          >
            Export to Excel
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 20 }}
            onClick={handleApproveAll}
          >
            Approve All
          </Button>
        </div>
      </Space>
      {!loading ? (
        <Table
          columns={columns}
          dataSource={filteredData}
          scroll={{ x: "max-content" }}
        />
      ) : (
        <Skeleton active />
      )}
      {/* <Modal
        title="Approve Leave Request"
        visible={isApproveModalVisible}
        onOk={confirmApprove}
        onCancel={() => setIsApproveModalVisible(false)}
      >
        <p>Are you sure you want to approve this leave request?</p>
      </Modal> */}
    </div>
  );
};

export default Attendance;
